export class ConsultantProfilemodule {
    constructor() {

        this.toggleReadMoreButton();
        this.addImageLiquid();
        this.setFocusToEnquiryForm();
    }



    toggleReadMoreButton() {
        $('#ReadMore').on("click", function (e) {
            e.preventDefault();
            var $button = $(this);
            var $textContainer = $button.closest(".read-more");
            $textContainer.toggleClass("expanded");

            if ($textContainer.hasClass("expanded")) {
                $button.text("Read less");
                //   window.scrollTo(window.scrollX, window.scrollY - 100);    

            } else {
                $button.text("Read more…");
                window.scrollTo(window.scrollX, $(e.target.hash).position().top - 150);
            }


        });


    }

    setFocusToEnquiryForm() {
        $('#btnEnquiry').on("click", function (e) {
            e.preventDefault();
            window.scrollTo(window.scrollX, window.scrollY + document.querySelector('#component-enquiryform').getBoundingClientRect().top - 200);
        });
    }

    addImageLiquid() {
        $('.consultant-listing__item__image--cropped').imgLiquid({
            horizontalAlign: '74%'
        });
    }
}

